import { useModules } from '@contexts/modules-provider';
import { AppLoader } from '@shared/components/app-loader/AppLoader';
import { ErrorPage } from '@shared/components/error-pages/ErrorPage';
import * as React from 'react';
import { Navigate } from 'react-router-dom';

import { ModuleSelectorGuardProps } from './ModuleSelectorGuard.types';

const ModuleSelectorGuard = React.memo(
  ({ children }: Readonly<ModuleSelectorGuardProps>): React.ReactElement => {
    const { modules, selectedModule, isModulesLoading } = useModules();

    if (isModulesLoading) {
      return <AppLoader />;
    }

    if (!modules || modules.length === 0) {
      return <ErrorPage type="not-found" />;
    }

    if (modules.length === 1) {
      return <Navigate to="/app-initializer" replace />;
    }

    if (selectedModule) {
      return <Navigate to="/app-initializer" replace />;
    }

    return children;
  }
);

ModuleSelectorGuard.displayName = 'ModuleSelectorGuard';

export { ModuleSelectorGuard };
